export const sectionCard =
  "bg-white border border-gray-200 rounded-2xl shadow-sm p-5 md:p-6";
export const inputClass =
  "w-full p-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#5c2f2f]/20 focus:border-[#5c2f2f]";
export const labelClass = "block text-sm font-semibold text-gray-800 mb-2";
export const helperClass = "text-xs text-gray-500 mt-1";
export const ALL_ATTRIBUTES_GROUP_ID = "__all_attributes__";
